module.exports = __webpack_public_path__ + "img/01.ccb9218d.jpg";